import TournamentsList from "./tournaments/TournamentsList.mjs";
import GamesTable from "./games/GamesTable.mjs";
import MccGamesTable from "./mcc-games/MccGamesTable.mjs";
import LiveWaitingListTable from "./mcc-games/LiveWaitingListTable.mjs";

export default function PokerLayout({ data, propertyCode }) {
  if (propertyCode === 'MCC') {
    return (<MiamiLayout data={data} />);
  }

  return (<DefaultLayout data={data} />);
}

function DefaultLayout({ data }) {
  return (
    <div className="row">
      <div className="col-lg-5 mb-5-5 mb-lg-0">
        <GamesTable data={data.get('liveCashGames')} />
      </div>
      <div className="col-lg-7">
        <TournamentsList data={data.get('liveTournaments')} />
      </div>
    </div>
  );
}

function MiamiLayout({ data }) {
  return (
    <div className="row">
      <div className="col-lg-7 mb-5-5 mb-lg-0">
        <MccGamesTable data={data.get('cashGames')} />
      </div>
      <div className="col-lg-5">
        <LiveWaitingListTable data={data.get('liveCashGames')} />
      </div>
    </div>
  );
}
